/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorPlugins } from '../../types/EditorPlugins';
import { DEFAULT_HEX_COLORS } from '../../constants/defaultHexColors';

export function getDefaultHexColors( editorPlugins: EditorPlugins ): string {
	if ( !editorPlugins.includes( 'EmailConfigurationHelper' ) ) {
		return '';
	}

	return `const DEFAULT_HEX_COLORS = ${ JSON.stringify( DEFAULT_HEX_COLORS ) }`;
}
